import { createEntityCollection } from '@/utils'

import { ROUTER_BASE_NAME } from '@/configs/env'
import { PRODUCT_STATUS_MAP, PAY_RESULT_SALE, PAY_RESULT } from '@/utils/const'
import { openWebView, openMiniProgram, isApp } from '@bcz/fe-interface'
import qs from 'qs'
import { PROGRAM_ID, SPECIAL_PRODUCT_IDS } from '@/utils/const'

/**
 * 将日期转化为月 日
 * @param {*} msec 毫秒
 * @param {*} split 分隔符
 */
export const formatDate = (msec, split = '') => {
  const date = new Date(msec)
  const mon = date.getMonth() + 1
  const day = date.getDate()
  if (!split) return `${mon}月${day}日`
  return `${mon}${split}${day}`
}

export const getConfirmUrl = productId => {
  let _url = PAY_RESULT

  if (SPECIAL_PRODUCT_IDS.indexOf(productId) > -1) {
    _url = PAY_RESULT_SALE
  }
  // else if (!isApp) { //要从订单维度区分是否是代付订单
  //   //非app  因为有很配置模块的跳转页面，不支持微信环境
  //   _url = PAY_RESULT11
  // }
  return `${location.protocol}//${
    location.hostname
  }/new-mall/confirm?successJump=${encodeURIComponent(_url)}`
}

export const noop = () => {}

/**
 * 将日期转化为月 日 时间
 * @param {*} msec 毫秒
 * @param {*} split 分隔符
 */
export const formatFullDateWithoutYear = (msec, split = '') => {
  if (!msec) return ''
  const date = new Date(msec)
  // const y = date.getFullYear()
  const mon = date.getMonth() + 1
  const day = date.getDate()
  const h = date.getHours()
  const m = date.getMinutes()
  if (!split) return `${mon}月${day}日 ${toTen(h)}:${toTen(m)}`
  return `${mon}${split}${day} ${toTen(h)}:${toTen(m)}`
}

/**
 * 将日期转化为年 月 日 小时 分钟
 * @param {*} msec 毫秒
 * @param {*} split 分隔符
 * @param {object} [opt] 分隔符
 */
export const formatFullDate = (msec, split = '', opt) => {
  if (!msec) return null
  const { needToTen } = opt || {}
  const date = new Date(msec)
  const y = date.getFullYear()
  const mon = date.getMonth() + 1
  const day = date.getDate()
  const h = date.getHours()
  const m = date.getMinutes()
  if (!split) return `${y}年${mon}月${day}日`
  if (needToTen) {
    return `${y}${split}${toTen(mon)}${split}${toTen(day)} ${toTen(h)}:${toTen(m)}`
  }
  return `${y}${split}${mon}${split}${day} ${toTen(h)}:${toTen(m)}`
}

/**
 * 将小于10的数字前面加 0
 */
export function toTen(num) {
  return num < 10 ? `0${num}` : num
}

export function goNav({ origin = location.origin, path = '', search = {}, link = '' }) {
  let [url, urlSearch] = (link || `${origin}${ROUTER_BASE_NAME}${path}`).split('?')
  const p = getUrlParam(location.search)
  const _url = getUrlParam(`?${urlSearch}`)
  url = `${url}?${qs.stringify(
    {
      ..._url,
      ...p,
      ...search,
    },
    { encode: false },
  )}`

  openWebView({
    url,
    title: '',
  }).catch(e => {
    location.assign(url)
  })
}

/**
 * className处理
 * @param {*} prefix
 * @returns
 */
export const cls = prefix => {
  return (c, pre) => {
    if (!c) return prefix
    const cA = c.split(' ')
    const p = pre ? `-${pre}` : ''
    return cA
      .map(item => {
        return `${prefix}${p}-${item}`
      })
      .join(' ')
  }
}

/**
 * 购买人数如果超过1w，采用万为单位
 * @param {number} count 购买人数
 */
export function getCountStr(count) {
  if (count < 10000) return '' + count
  count = count / 10000
  return `${count.toFixed(1)}万`
}

/**
 * 金额转换
 * @param {number} num 金额，单位：分
 * @param {number} [fixed] 需要保留的小数点
 * @returns
 */
export function getPriceText(num, fixed) {
  if (typeof num === 'undefined') return ''
  if (fixed > 0) {
    return (num / 100).toFixed(fixed)
  }
  if (num % 100 === 0) {
    return parseInt(num / 100 + '')
  } else if (num % 10 === 0) {
    return (num / 100).toFixed(1)
  }
  return (num / 100).toFixed(2)
}

export function getCommentDate(ms, split) {
  const _d = new Date(ms)
  const nowDate = new Date()
  const now = nowDate.getTime()
  const dis = 31 * 24 * 60 * 60 * 1000 //30天
  const diff = now - ms
  if (diff >= dis) {
    const y = _d.getFullYear()
    const m = _d.getMonth() + 1
    const d = _d.getDate()
    //显示年月日
    return `${y}${split}${m}${split}${d}`
  } else {
    const diffD = Math.floor(diff / 24 / 60 / 60 / 1000)
    if (diffD > 0) {
      return `${diffD}天前`
    }
    return `今天`
  }
}

/**
 * 根据传入时间获取时间对象
 * @param {number} times 毫秒数
 * @returns {{day: number,hour:number,min: number,secend: number}}
 */
export function getDateObj(times = 0) {
  if (times < 0)
    return {
      day: 0,
      hour: 0,
      min: 0,
      secend: 0,
    }
  const d = Math.floor(times / 86400000)
  const h = Math.floor(times / 1000 / 60 / 60) % 24
  const m = Math.floor((times / 1000 / 60) % 60)
  const s = Math.floor((times / 1000) % 60)
  return {
    day: d,
    hour: h,
    min: m,
    secend: s,
  }
}

//如果没有指定key，则返回参数对象
/**
 *
 * @param {*} search
 * @param {object} [opt]
 * @param {string} [opt.key]
 * @param {boolean} [opt.needDecode]
 * @returns
 */
export function getUrlParam(search, opt) {
  if (!search) return {}
  const { key, needDecode } = opt || {}
  let result = {}
  const params = search.indexOf('?') > -1 ? search.substring(1).split('&') : search.split('&')
  for (let i = 0, len = params.length; i < len; i++) {
    const item = params[i].split('=')
    const v = needDecode ? decodeURIComponent(item[1]) : item[1]
    if (item[0] === key) {
      return v
    } else {
      result[item[0]] = v
    }
  }

  return result
}

export function paramsToString(obj) {
  const keys = Object.keys(obj)
  let res = ''
  for (let i = 0, len = keys.length; i < len; i++) {
    const key = keys[i]
    if (obj[key] === '' || typeof obj[key] === 'undefined') continue
    res += `&${key}=${obj[key]}`
  }

  return res.substring(1)
}

export const isContainer = (node, targetClass) => {
  const judge = cur => {
    if (!cur) return false
    if (cur.tagName === 'BODY' || cur.tagName === 'DOCUMENT') return false
    if (cur.className.indexOf(targetClass) > -1) {
      return true
    }
    return judge(cur.parentNode)
  }

  return judge(node)
}

export const isObject = val => {
  return Object.prototype.toString.call(val) === '[object Object]'
}
export const isFunction = val => {
  return Object.prototype.toString.call(val) === '[object Function]'
}
/**
 * 判断是否为空对象
 * @param {*} val
 * @returns {number} -1:不是对象， 0: 不是空对象 1: 空对象
 */
export const isEmpty = val => {
  if (!isObject(val)) {
    return -1
  }
  const keys = Object.keys(val)
  return keys.length > 0 ? 0 : 1
}

/**
 * 判断prevDay 是否是 target  的 否是前一天
 * @param {*} target
 * @param {*} prevDay
 * @returns
 */
export const isPrevDays = (target, prevDay) => {
  const c = prevDay ? new Date(prevDay).getTime() : new Date().getTime()
  const t = new Date(target)
  const dayMs = 24 * 60 * 60 * 1000
  const tzero = new Date(
    `${t.getFullYear()}/${toTen(t.getMonth() + 1)}/${toTen(t.getDate())}`,
  ).getTime()
  return c < tzero && c >= tzero - dayMs
}

/**
 * 生成一个用不重复的ID
 */
export const genNonDuplicateID = (randomLength = 4) => {
  let idStr = Date.now().toString(36)

  idStr += Math.random().toString(36).substr(2, randomLength)
  return idStr
}

//

/**
 * 打开小程序 兼容
 * @param {string} url
 */
export const openMini = url => {
  //小程序直接打开
  if (isApp) {
    openMiniProgram({
      programId: PROGRAM_ID,
      programPath: `/pages/tmplate_public/index?url=${encodeURIComponent(url)}`,
    })
  } else {
    window.location.href = url
  }
}

/**
 * 处理选择商品
 * @param {*} products //正常商品
 * @param {*} stepGoods //多件多折商品
 * @returns
 */
export const formatPayData = (products, stepGoods) => {
  if (!products && !stepGoods) return ''
  const { list: _l, entities } = products || {}
  const { list: _sL, entities: sEnt } = stepGoods || {}
  const list = Array.isArray(_l) ? _l : []
  const sList = Array.isArray(_sL) ? _sL : []
  const res = []
  for (let i = 0, len = list.length; i < len; i++) {
    const key = list[i]
    const { itemId, subItemId, count, selected, status } = entities[key]
    if (selected && status !== PRODUCT_STATUS_MAP.PRE_SELL) {
      res.push(`${itemId}_${subItemId}_${count}`)
    }
  }

  for (let i = 0, len = sList.length; i < len; i++) {
    const key = sList[i]
    const { itemId, subItemId, count, selected, status } = sEnt[key] || {}
    if (selected && status !== PRODUCT_STATUS_MAP.PRE_SELL) {
      res.push(`${itemId}_${subItemId}_${count}`)
    }
  }
  return res.join(',')
}

export const deFromatePayData = str => {
  try {
    const s = str.split(',')
    const _arr = s.map(item => {
      if (!item) return null
      const itemArr = item.split('_')
      return {
        itemId: itemArr[0] | 0,
        subItemId: itemArr[1] | 0,
        count: itemArr[2] | 0,
      }
    })
    return _arr.filter(item => {
      return item
    })
  } catch (e) {
    return null
  }
}

/**
 * 处理活动商品
 * @param {*} list
 * @param {*} opt
 * @returns
 */
export const formatActPayData = (list, opt) => {
  const { canJion, actId } = opt || {}
  if (!canJion) return ''
  if (!actId) return ''
  if (!Array.isArray(list) || list.length < 1) return ''
  const res = []
  for (let i = 0, len = list.length; i < len; i++) {
    const item = list[i]
    res.push(`${actId}_${item.itemId}_${item.subItemId}_1`)
  }

  return res.join(',')
}

export const deFormatActPayData = str => {
  try {
    if (!str) return
    const s = str.split(',')
    return s.map(item => {
      const itemArr = item.split('_')
      return {
        activityId: parseInt(itemArr[0] || 0),
        subItemId: itemArr[2] | 0,
        count: parseInt(itemArr[3], 10),
      }
    })
  } catch (e) {
    console.log('e -----------', e)
  }
}

export const getCookie = key => {
  const cookie = document.cookie
  const cA = cookie.split(';')
  if (!Array.isArray(cA) || cA.length === 0) return ''
  for (let i = 0, len = cA.length; i < len; i++) {
    const v = cA[i]
    const v1 = v.split('=')
    const _key = v1[0].replace(/\s/, '')
    if (_key === key) {
      return v1[1]
    }
  }

  return ''
}

//获取订金预售信息
/**
 *
 * @param {*} obj
 * @param {number} [subItemId] 如果有subItemId，代表需要根据 subItemId 来判断是否参与了订金预售活动，订单确认页需要
 * @returns
 */
export const getPaymentPreInfo = (obj, subItemId) => {
  if (!isObject(obj)) return {}
  const {
    downPaymentStartTime,
    downPaymentEndTime,
    balancePaymentEndTime,
    balancePaymentStartTime,
    depositItems,
    id,
  } = obj

  //是预售活动
  const { entities, list } = createEntityCollection(depositItems || [], item => {
    return item.subItemId
  })
  if (subItemId) {
    if (!entities[subItemId]) {
      return {
        isPaymentPre: false,
      }
    } else {
      const { downPaymentAmount: preAmount, discountAmount, price } = entities[subItemId]
      return {
        isPaymentPre: true,
        downPaymentStartTime,
        downPaymentEndTime,
        balancePaymentEndTime,
        balancePaymentStartTime,
        downPaymentAmount: entities[subItemId].downPaymentAmount,
        downDiscountAmount: entities[subItemId].discountAmount,
        //尾款 （尾款支付价=预售价格-首付金额-优惠金额）
        downEndAmount: price - preAmount - discountAmount,
      }
    }
  } else {
    const totalSale = list.reduce((total, currentValue) => {
      return total + entities[currentValue].soldCount
    }, 0)
    return {
      isPaymentPre: true,
      downPaymentStartTime,
      downPaymentEndTime,
      balancePaymentEndTime,
      balancePaymentStartTime,
      totalSale,
      id,
      downPaymentAmount: entities[list[0]].downPaymentAmount,
      downDiscountAmount: entities[list[0]].discountAmount,
      ...entities,
    }
  }
}
